import { DateTime } from "luxon";

// mui components
import { Checkbox, TableCell, TableRow, IconButton, Stack } from "@mui/material";
import { VisibilityOutlined, DownloadOutlined } from "@mui/icons-material";

// custom components
import Body2 from "../../typography/body-02";

// utils
import { isBrowserRenderable } from "../../../utils/document-validation";

const LoanDocumentRow = ({ 
    row, 
    handleRowClick, 
    selectedRow, 
    onViewDocument,
    onDownloadDocument
}) => {
	const isSelected = (name) => selectedRow.indexOf(name) !== -1;

	const isItemSelected = isSelected(row?.entityId);
	const labelId = `enhanced-table-checkbox-${row?.entityId}`;
	
	const fileName = row?.entityName;
	const isRenderable = isBrowserRenderable(fileName);

    const handleViewClick = (event) => {
		event.stopPropagation(); // Prevent row selection
		onViewDocument(row, isRenderable);
	};

    const handleDownloadClick = (event) => {
        event.stopPropagation();
        onDownloadDocument(row);
    };

	return (
		<TableRow
			hover
			tabIndex={-1}
			key={row?.entityId}
			onClick={(event) => handleRowClick(event, row?.entityId)}
			role="checkbox"
			aria-checked={isItemSelected}
			selected={isItemSelected}
			sx={{
				"& td": {
					py: 0.25,
				},
			}}
		>
			<TableCell padding="checkbox"
				sx={{
					pl: 4,
				}}
			>
				<Checkbox
					color="primary"
					checked={isItemSelected}
					inputProps={{
						"aria-labelledby": labelId,
					}}
				/>
			</TableCell>
			<TableCell>
				<Body2 text={row?.entityName} />
			</TableCell>
			<TableCell>
				<Body2
					text={DateTime.fromISO(row?.createdDate, {
						zone: "America/New_York",
					}).toFormat("MM/dd/yyyy HH:mm a")}
				/>
			</TableCell>
			<TableCell>
				<Body2 text={row?.isActive ? "Yes" : "No"} />
			</TableCell>
            <TableCell>
                <Stack direction="row" alignItems="center" gap={1}>
                    <IconButton
                        onClick={handleViewClick}
                        size="small"
                        title="View document"
                        sx={{ 
                            padding: '4px',
                            '&:hover': { backgroundColor: 'transparent' }
                        }}
                    >
                        <VisibilityOutlined fontSize="small" />
                    </IconButton>
                    <IconButton
                        onClick={handleDownloadClick}
                        size="small"
                        title="Download document"
                        sx={{ 
                            padding: '4px',
                            '&:hover': { backgroundColor: 'transparent' }
                        }}
                    >
                        <DownloadOutlined fontSize="small" />
                    </IconButton>
                </Stack>
            </TableCell>
		</TableRow>
	);
};

export default LoanDocumentRow;
